import moment from "moment";
import {giveTextColorForBackGroundColor} from "@/util/ColorUtil";

class WorkShift {

    constructor(shiftTypeId, labourPeriod, breakPeriod, color, name, customerName, contractId, remark, workedHours, interrupted, callout, editedByAdmin) {
        this.customerName = customerName;
        this.contractId = contractId;
        this.title = name;
        this.color = color;
        this.textColor = giveTextColorForBackGroundColor(color);
        this.labourPeriod = labourPeriod;
        this.breakPeriod = breakPeriod;
        this.allDay = true;
        this.shiftTypeId = shiftTypeId;
        this.remark = remark;
        this.workedHours = workedHours;
        this.interrupted = interrupted;
        this.callout = callout;
        this.editedByAdmin = editedByAdmin;
    }

    get labourPeriodStartHours() {
        return moment(this.labourPeriod.startDateTimestamp).format("HH:mm");
    }

    get labourPeriodEndHours() {
        return moment(this.labourPeriod.endDateTimestamp).format("HH:mm");
    }

    get breakPeriodStartHours() {
        if (this.breakPeriod) {
            return moment(this.breakPeriod.startDateTimestamp).format("HH:mm");
        }
        return '';
    }

    get breakPeriodEndHours() {
        if (this.breakPeriod) {
            return moment(this.breakPeriod.endDateTimestamp).format("HH:mm");
        }
        return '';
    }

    get startDate() {
        return moment(this.labourPeriod.startDateTimestamp).format("YYYY-MM-DD");
    }
}

export default WorkShift;
